import React from 'react'
import { FormattedDate, FormattedTime, useIntl } from 'react-intl'
import { selectUnit } from '@formatjs/intl-utils'
import Icon from 'components/Icon'

const Feedback = ({ last, timestamp, body, meta }) => {
  const { to, nps } = meta

  return (
    <li>
      <div className="relative pb-8">
        { !last &&
          <span className="absolute top-5 left-5 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>
        }
        <div className="relative flex items-start space-x-3">
          <div>
            <div className="relative px-2 mt-2">
              <div className="h-6 w-6 bg-yellow-400 rounded-full ring-4 ring-white flex justify-center items-center">
                <Icon icon="star" className="text-xs text-white" />
              </div>
            </div>
          </div>

          <div className="min-w-0 flex-1 py-0">
            <div className="text-sm leading-6">
              <div className="border border-gray-200 rounded-sm mb-2">
                <div className="p-2">
                  <div className="text-xs font-gray-700 font-medium">
                  {to && !!to.length ? (
                    <>To { to.join(', ') }</>
                  ) : (
                    <>Overall</>
                  )
                  }
                    
                  </div>

                  { body }
                </div>

                <div className="border-t border-gray-200 px-2 space-x-1 flex justify-between items-center">
                  <span className="text-gray-400">
                    Rating
                  </span>

                  { [...Array(5)].map((_, index) => (
                    <Icon
                      key={index}
                      icon="star"
                      className={index >= nps ? `text-gray-300` : `text-yellow-400`}
                    />
                  )) }
                </div>
              </div>

              <span className="whitespace-nowrap text-gray-500 text-xs">
                <FormattedDate value={timestamp * 1000} /> <FormattedTime value={timestamp * 1000} />
              </span>
            </div>
          </div>
        </div>
      </div>
    </li>
  )
}

export default Feedback
